module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ashou11-216b063ef2d69981935a0b7be8e08f0d.jpg";